import React, { useState } from 'react'
import { useForm, SubmitHandler } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'
import { client } from '../../utils/api-client'
import { makeNumbersFarsi, makeNumbersLatin } from 'utils/farsi'
import { Helmet } from 'react-helmet-async'

interface IFormInput {
  username: number | string
}

export const ForgotPasswordForm = () => {
  const navigate = useNavigate()
  const { register, handleSubmit, setFocus, setValue } = useForm<IFormInput>()
  const onSubmit: SubmitHandler<IFormInput> = async (data) => {
    const normalizedUsername = makeNumbersLatin(String(data.username ?? ''))
    const payload = { username: normalizedUsername }
    const result = await client('user/reset-password-code', { data: payload })
    if (result)
      navigate('/forgot-password-verification-code', {
        state: { username: data },
      })
  }

  React.useEffect(() => {
    setFocus('username')
  }, [setFocus])

  const handlePhoneNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const farsiNumber = makeNumbersFarsi(e.target.value)
    setValue('username', farsiNumber) // Update form value
  }

  const handleGoToLoginPage = () => {
    navigate('/login')
  }
  return (
    <div
      className='max-w-lg mx-auto flex flex-col my-10 sm:my-12 h-auto border py-8 px-4 rounded-md'
      style={{
        backgroundColor: 'var(--card-bg)',
        color: 'var(--text-primary)',
        borderColor: 'var(--border-color)',
      }}
    >
      <Helmet>
        <title className='text-xl font-semibold'>فراموشی رمز عبور</title>
        <meta
          name='description'
          content='بوک استوری - هر کتاب یک داستان، هر داستان یک زندگی دوباره'
        />
      </Helmet>
      <button
        onClick={handleGoToLoginPage}
        className='w-full rounded text-white uppercase border-none mb-4 py-3 px-4 text-base sm:text-lg font-medium active:transition-all active:duration-[0.3s] active:opacity-80 cursor-pointer'
        style={{ backgroundColor: 'var(--accent-primary)' }}
      >
        رفتن به صفحه ورود
      </button>
      <form onSubmit={handleSubmit(onSubmit)}>
        <h2 className='text-base text-start font-medium mb-3'>
          رمز عبورتون رو فراموش کردید؟ مشکلی نیست برای همه پیش میاد. <br />
          لطفا شماره تلفن خودتون رو وارد کنید تا کد تایید ارسال شه براتون.
        </h2>
        <h1 className='text-xl text-right font-medium mt-4'>شماره تلفن شما:</h1>
        <input
          className='input-theme block outline-none w-full rounded border p-4 text-base sm:text-lg my-4'
          {...register('username', {
            required: true,
            maxLength: 13,
            onChange: handlePhoneNumberChange,
          })}
          dir='ltr'
        />
        <input
          className='w-full rounded text-white uppercase border-none mt-2 py-3 sm:py-4 px-4 text-base sm:text-lg font-medium active:transition-all active:duration-[0.3s] active:opacity-80 cursor-pointer'
          style={{ backgroundColor: 'var(--accent-primary)' }}
          type='submit'
          value='ادامه'
        />
      </form>
    </div>
  )
}
